import { render, staticRenderFns } from "./KnowledgeBaseSectionPage.vue?vue&type=template&id=1fc7893a&scoped=true"
import script from "./KnowledgeBaseSectionPage.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseSectionPage.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseSectionPage.vue?vue&type=style&index=0&id=1fc7893a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc7893a",
  null
  
)

export default component.exports